(() => {
  const endpoint = '/apps/b2b-checkout/stock-status';
  const TAZELIK_MS = 30000;
  const cache = new Map();
  const nativeFetch = window.fetch.bind(window);

  function onbellektenAl(id) {
    const kayit = cache.get(String(id));
    if (!kayit) return null;
    if (Date.now() - kayit.zaman > TAZELIK_MS) { cache.delete(String(id)); return null; }
    return kayit.adet;
  }

  function onbellegiBosalt() { cache.clear(); }

  async function stock(ids) {
    const missing = [...new Set(ids.map(String))].filter((id) => onbellektenAl(id) === null);
    // Stok ucu cevap vermezse satisi KESME. Uc calisirken koruma aynen surer;
    let degraded = false;
    if (missing.length) {
      try {
        const response = await nativeFetch(`${endpoint}?variant_ids=${missing.join(',')}`, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`stok ucu ${response.status}`);
        const payload = await response.json();
        Object.entries(payload.stock || {}).forEach(([id, qty]) =>
          cache.set(String(id), { adet: Number(qty) || 0, zaman: Date.now() }));
      } catch (error) {
        degraded = true;
        console.warn('[adell-b2c-stock-guard] stok ucu yanit vermedi, kontrol atlandi:', error && error.message);
      }
    }
    return Object.fromEntries(ids.map((id) => {
      const key = String(id);
      const adet = onbellektenAl(key);
      if (adet !== null) return [key, adet];
      return [key, degraded ? Infinity : 0];
    }));
  }

  function soldOut(message = 'Bu ürünün stoğu tükenmiştir.') {
    document.dispatchEvent(new CustomEvent('cart:error', { detail: { message } }));
    window.alert(message);
  }

  /** Sepetteki varyant -> toplam adet. Okunamazsa bos doner (fail-open). */
  async function sepetAdetleri() {
    try {
      const cart = await nativeFetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      const harita = {};
      (cart.items || []).forEach((line) => {
        const anahtar = String(line.variant_id);
        harita[anahtar] = (harita[anahtar] || 0) + Number(line.quantity || 0);
      });
      return harita;
    } catch (_) {
      return {};
    }
  }

  /** /cart/add govdesinin tum bicimlerini tek listeye cevirir. */
  function eklenecekler(body) {
    if (body instanceof FormData || body instanceof URLSearchParams) {
      const id = body.get('id');
      return id ? [{ id, quantity: Number(body.get('quantity') || 1) }] : [];
    }
    let value = body;
    if (typeof body === 'string') {
      try { value = JSON.parse(body); } catch { return []; }
    }
    if (!value || typeof value !== 'object') return [];
    if (Array.isArray(value.items)) {
      return value.items
        .filter((satir) => satir && satir.id)
        .map((satir) => ({ id: satir.id, quantity: Number(satir.quantity || 1) }));
    }
    return value.id ? [{ id: value.id, quantity: Number(value.quantity || 1) }] : [];
  }

  // adede bakiliyordu; stok 1 iken "Sepete Ekle"ye iki kez basmak sepete 2 koyuyordu
  async function validateAdd(body) {
    const istekler = eklenecekler(body);
    if (!istekler.length) return null;
    const levels = await stock(istekler.map((satir) => satir.id));
    const sepet = await sepetAdetleri();
    for (const satir of istekler) {
      const sinir = levels[String(satir.id)];
      if (!Number.isFinite(sinir)) continue;
      const mevcut = sepet[String(satir.id)] || 0;
      const istenen = Number.isFinite(satir.quantity) && satir.quantity > 0 ? satir.quantity : 1;
      if (mevcut + istenen > sinir) {
        if (sinir < 1) return 'Bu ürünün stoğu tükenmiştir.';
        if (mevcut >= sinir) {
          return `Bu üründen stokta olan ${sinir} adedin tamamı sepetinizde.`;
        }
        return `Bu üründen en fazla ${sinir} adet alabilirsiniz; sepetinizde ${mevcut} adet var.`;
      }
    }
    return null;
  }

  function bodyValue(body) {
    if (body instanceof FormData || body instanceof URLSearchParams) return Object.fromEntries(body.entries());
    if (typeof body === 'string') { try { return JSON.parse(body); } catch { return {}; } }
    return body || {};
  }

  async function validateCartChange(body) {
    const value = bodyValue(body);
    const quantity = Number(value.quantity);
    if (!Number.isFinite(quantity) || quantity < 1) return true;
    const cart = await nativeFetch('/cart.js', { credentials: 'same-origin' }).then((response) => response.json());
    const item = value.id ? cart.items.find((line) => String(line.key) === String(value.id) || String(line.variant_id) === String(value.id)) : cart.items[Number(value.line) - 1];
    if (!item) return true;
    const levels = await stock([item.variant_id]);
    return quantity <= levels[String(item.variant_id)];
  }

  async function validateCartUpdate(body) {
    const updates = bodyValue(body).updates;
    if (!updates) return true;
    const cart = await nativeFetch('/cart.js', { credentials: 'same-origin' }).then((response) => response.json());
    const entries = Array.isArray(updates)
      ? updates.map((quantity, index) => [cart.items[index]?.variant_id, quantity])
      : Object.entries(updates).map(([key, quantity]) => [cart.items.find((line) => line.key === key || String(line.variant_id) === key)?.variant_id, quantity]);
    const requested = entries.filter(([id, quantity]) => id && Number(quantity) > 0);
    const levels = await stock(requested.map(([id]) => id));
    return requested.every(([id, quantity]) => Number(quantity) <= levels[String(id)]);
  }

  async function checkUrl(url, body) {
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)) {
      const engel = await validateAdd(body);
      if (engel) return engel;
    }
    if (/\/cart\/change(?:\.js)?(?:\?|$)/.test(url)) {
      if (!(await validateCartChange(body))) return 'Talep ettiğiniz adet perakende stoğunu aşıyor.';
    }
    if (/\/cart\/update(?:\.js)?(?:\?|$)/.test(url)) {
      if (!(await validateCartUpdate(body))) return 'Talep ettiğiniz adet perakende stoğunu aşıyor.';
    }
    return null;
  }

  const SEPET_YAZMA = /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/;

  window.fetch = async function guardedFetch(input, init = {}) {
    const url = typeof input === 'string' ? input : input?.url || '';
    const blockMessage = await checkUrl(url, init.body);
    if (blockMessage) { soldOut(blockMessage); throw new Error('B2C_STOCK_EXCEEDED'); }
    const cevap = await nativeFetch(input, init);
    // uctan yeniden okusun.
    if (SEPET_YAZMA.test(url)) onbellegiBosalt();
    return cevap;
  };

  const NativeXHROpen = XMLHttpRequest.prototype.open;
  const NativeXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function guardedOpen(method, url, ...rest) {
    this.__b2cGuardUrl = url;
    return NativeXHROpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function guardedSend(body) {
    const url = this.__b2cGuardUrl || '';
    if (!/\/cart\/(add|change|update)(?:\.js)?(?:\?|$)/.test(url)) return NativeXHRSend.call(this, body);
    const xhr = this;
    checkUrl(url, body).then((blockMessage) => {
      if (blockMessage) { soldOut(blockMessage); xhr.dispatchEvent(new Event('error')); return; }
      xhr.addEventListener('load', onbellegiBosalt, { once: true });
      NativeXHRSend.call(xhr, body);
    }).catch(() => NativeXHRSend.call(xhr, body));
    return undefined;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!/\/cart\/add(?:\.js)?(?:\?|$)/.test(action)) return;
    if (form.getAttribute('is') === 'product-form') return;
    event.preventDefault();
    validateAdd(new FormData(form)).then((engel) => {
      if (engel) { soldOut(engel); return; }
      form.submit();
    });
  }, true);

  async function refreshProductButton() {
    if (!document.body.classList.contains('product-template')) return;
    const form = [...document.querySelectorAll('form[action*="/cart/add"]')].find((candidate) =>
      candidate.querySelector('[name="id"]') && candidate.querySelector('[name="add"], button[type="submit"]')
    );
    const id = form?.querySelector('[name="id"]')?.value;
    const button = form?.querySelector('[name="add"], button[type="submit"]');
    if (!id || !button) return;
    try {
      const levels = await stock([id]);
      const unavailable = levels[String(id)] < 1;
      const label = button.querySelector('span') || button;
      const strings = (window.FoxTheme && window.FoxTheme.variantStrings) || {};
      button.disabled = unavailable;
      button.setAttribute('aria-disabled', String(unavailable));
      label.textContent = unavailable ? (strings.soldOut || 'Tükendi') : (strings.addToCart || 'Sepete Ekle');
      document.querySelectorAll('variant-selects input:checked, variant-radios input:checked').forEach((input) => {
        input.classList.toggle('disabled', unavailable);
        input.setAttribute('aria-disabled', String(unavailable));
      });
    } catch (_) {}
  }

  document.addEventListener('change', (event) => {
    if (event.target?.matches('[name="id"], variant-selects select, variant-radios input')) setTimeout(refreshProductButton, 50);
  });
  document.addEventListener('variant:changed', () => setTimeout(refreshProductButton, 0));
  document.addEventListener('DOMContentLoaded', refreshProductButton);

  function initWishlistStock() {
    if (!/\/apps\/wishlistr\/pages\/wishlist\/?$/.test(window.location.pathname)) return;
    const root = document.getElementById('MainContent');
    if (!root) return;
    const states = new WeakMap();
    let scheduled = false;
    let bulkState;
    const strings = () => window.FoxTheme?.variantStrings || {};
    const variantId = (button) => {
      const value = button.closest('.wl-card')?.querySelector('select')?.value || button.dataset.variantId || '';
      return String(value).match(/(?:^|\/)(\d+)$/)?.[1] || '';
    };
    const setAttribute = (button, name, value) => {
      if (button.getAttribute(name) !== value) button.setAttribute(name, value);
    };
    const refreshBulk = () => {
      const button = root.querySelector('#add-all-to-cart');
      if (!button) return;
      const blocked = Array.from(root.querySelectorAll('.wl-card .wl-btn-atc')).some((item) => {
        const state = states.get(item);
        return state?.pending || state?.unavailable;
      });
      if (blocked) {
        if (bulkState?.button !== button) bulkState = { button, wasDisabled: button.disabled };
        if (!button.disabled) button.disabled = true;
        setAttribute(button, 'aria-disabled', 'true');
      } else if (bulkState?.button === button) {
        button.disabled = bulkState.wasDisabled;
        setAttribute(button, 'aria-disabled', String(bulkState.wasDisabled));
        bulkState = undefined;
      }
    };
    const applyState = (button, state) => {
      const blocked = state.pending || state.unavailable;
      if (blocked) {
        if (!button.disabled) button.disabled = true;
        setAttribute(button, 'aria-disabled', 'true');
        if (state.pending) setAttribute(button, 'aria-busy', 'true');
      } else if (state.ownsDisabled) {
        button.disabled = state.wasDisabled;
        setAttribute(button, 'aria-disabled', String(state.wasDisabled));
        state.ownsDisabled = false;
      }
      if (!state.pending) {
        button.removeAttribute('aria-busy');
        const label = state.unavailable ? (strings().soldOut || 'Tükendi') : (strings().addToCart || 'Sepete Ekle');
        if (state.unavailable || state.restoreLabel) {
          if (button.textContent.trim() !== label) button.textContent = label;
          state.restoreLabel = false;
        }
      }
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(() => {
        scheduled = false;
        refresh();
      });
    };
    const refresh = async () => {
      const pending = [];
      root.querySelectorAll('.wl-card .wl-btn-atc').forEach((button) => {
        const id = variantId(button);
        if (!id) return;
        const previous = states.get(button);
        if (previous?.id === id && (previous.pending || Date.now() - previous.checkedAt < TAZELIK_MS)) {
          if (previous.pending || previous.unavailable) applyState(button, previous);
          return;
        }
        const state = {
          id,
          pending: true,
          unavailable: false,
          wasDisabled: previous?.ownsDisabled ? previous.wasDisabled : button.disabled,
          ownsDisabled: true,
          restoreLabel: !!previous?.unavailable,
        };
        states.set(button, state);
        applyState(button, state);
        pending.push({ button, state });
      });
      refreshBulk();
      if (!pending.length) return;
      let timeout;
      const levels = await Promise.race([
        stock(pending.map(({ state }) => state.id)),
        new Promise((resolve) => { timeout = setTimeout(() => resolve({}), 10000); }),
      ]);
      clearTimeout(timeout);
      pending.forEach(({ button, state }) => {
        if (!button.isConnected || states.get(button) !== state) return;
        if (variantId(button) !== state.id) { schedule(); return; }
        state.pending = false;
        state.unavailable = Number.isFinite(levels[state.id]) && levels[state.id] < 1;
        state.checkedAt = Date.now();
        applyState(button, state);
      });
      refreshBulk();
    };
    root.addEventListener('change', (event) => {
      if (event.target.matches('.wl-card select')) refresh();
    }, true);
    new MutationObserver(schedule).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-variant-id', 'disabled'],
    });
    window.addEventListener('focus', schedule);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) schedule();
    });
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initWishlistStock);
  else initWishlistStock();
})();
